"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userLanguages = exports.entityProfilesStatus = exports.phasesArray = exports.customPhase = exports.manualLitigationSource = exports.permissionRoles = exports.NotificationTypes = exports.OrderingTypes = exports.CRUDTypes = exports.PaymentTypes = exports.EntityTypes = exports.AppTypes = void 0;
var AppTypes = {
  MD: 'md',
  BPI: 'bpi',
  AVOAPP: 'avoapp'
};
exports.AppTypes = AppTypes;
var EntityTypes = {
  PERSON: 'person',
  COMPANY: 'company'
};
exports.EntityTypes = EntityTypes;
var PaymentTypes = {
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
  SUBSCRIPTION: 'subscription'
};
exports.PaymentTypes = PaymentTypes;
var CRUDTypes = {
  create: {
    name: 'create',
    number: 1
  },
  read: {
    name: 'read',
    number: 2
  },
  update: {
    name: 'update',
    number: 3
  },
  destroy: {
    name: 'destroy',
    number: 4
  }
};
exports.CRUDTypes = CRUDTypes;
var OrderingTypes = {
  INTERVAL_ASC: 'interval',
  INTERVAL_DESC: '-interval'
};
exports.OrderingTypes = OrderingTypes;
var NotificationTypes = {
  LITIGATION: 'litigation',
  UPCOMING_HEARING: 'upcoming_hearing',
  PARTY: 'party'
};
exports.NotificationTypes = NotificationTypes;
var permissionRoles = {
  manager: {
    value: 'manager',
    label: 'Manager'
  },
  internalCollaborator: {
    value: 'internal_collaborator',
    label: 'Colaborator Intern'
  }
};
exports.permissionRoles = permissionRoles;
var manualLitigationSource = 'manual';
exports.manualLitigationSource = manualLitigationSource;
var customPhase = {
  label: 'Customizat',
  value: 'custom'
};
exports.customPhase = customPhase;
var phasesArray = [{
  value: 'Fond',
  label: 'Fond'
}, {
  value: 'Apel',
  label: 'Apel'
}, {
  value: 'Recurs',
  label: 'Recurs'
}, {
  value: 'Contestație',
  label: 'Contestație'
}, {
  value: customPhase.value,
  label: customPhase.label
}];
exports.phasesArray = phasesArray;
var entityProfilesStatus = {
  ACTIVE: {
    value: 'active',
    label: 'Activ'
  },
  PENDING: {
    value: 'pending',
    label: 'Așteptare răspuns',
    action: 'Verifică email-ul și acceptă invitația'
  },
  REJECTED: {
    value: 'rejected',
    label: 'Refuzat'
  },
  DELTED: {
    value: 'deleted',
    label: 'Șters'
  }
};
exports.entityProfilesStatus = entityProfilesStatus;
var userLanguages = {
  RO: {
    value: 'RO',
    label: 'Română'
  },
  EN: {
    value: 'EN',
    label: 'English'
  },
  DE: {
    value: 'DE',
    label: 'Deutsch'
  },
  FR: {
    value: 'FR',
    label: 'Français'
  },
  IT: {
    value: 'IT',
    label: 'Italiano'
  },
  ES: {
    value: 'ES',
    label: 'Español'
  }
};
exports.userLanguages = userLanguages;